<div>
    <div class="fc-product-detail-attributes-accordion" fc-skeleton>
        <fcp-accordion>
            <!-- Manufacturer Attributes -->
            <fcp-accordion-item [title]="'ORDER.PRODUCT_DETAILS.ARTICLE_ATTRIBUTES' | translate">
                <div *ngIf="hasMetadata" class="fc-product-detail-product-attributes">
                    <!-- Main attributes -->
                    <div class="fc-product-detail-attributes-container">
                        <div
                            *ngFor="let attribute of metadata.mainAttributes"
                            data-e2e-hook="pdp-main-manufacturer-attribute"
                            class="fc-product-detail-attribute"
                        >
                            <div>
                                <span
                                    ><strong>{{ attribute.translationKey | translate }}</strong></span
                                >
                            </div>

                            <div>
                                <span>{{ attribute.value }}</span>
                            </div>
                        </div>
                    </div>

                    <!-- Description -->
                    <div
                        *ngIf="metadata.description"
                        data-e2e-hook="pdp-description"
                        class="fc-product-detail-product-attributes"
                    >
                        <div>
                            <span
                                ><strong>{{ metadata.description.translationKey | translate }}</strong></span
                            >
                        </div>

                        <div>
                            <span>{{ metadata.description.value }}</span>
                        </div>
                    </div>

                    <!-- FC attributes -->
                    <ng-container *ngFor="let attribute of fashionCloudAttributes">
                        <!-- Just displaying 'sole removable' for now -->
                        <div
                            *ngIf="attribute.name === 'soleRemovable'"
                            data-e2e-hook="pdp-soleRemovable"
                            class="fc-product-detail-product-attributes"
                        >
                            <div>
                                <span
                                    ><strong>{{ attribute.translationKey | translate }}</strong></span
                                >
                            </div>

                            <div>
                                <span>{{ attribute.value }}</span>
                            </div>
                        </div>
                    </ng-container>

                    <!-- Additional attributes -->
                    <div *ngFor="let attribute of metadata.extraAttributes">
                        <div
                            data-e2e-hook="pdp-additional-manufacturer-attribute"
                            class="fc-product-detail-product-attributes"
                        >
                            <div>
                                <span>
                                    <strong>{{ attribute.translationKey | translate }}</strong>
                                </span>
                            </div>

                            <div>
                                <span>{{ attribute.value }}</span>
                            </div>
                        </div>
                    </div>
                </div>
            </fcp-accordion-item>
            <!-- Sustainability Attributes -->
            <fcp-accordion-item
                *ngIf="hasSustainabilityAttributes"
                [title]="'ORDER.PRODUCT_DETAILS.SUSTAINABILITY_ATTRIBUTES' | translate"
            >
                <div class="fc-product-detail-product-attributes">
                    <div class="fc-product-detail-attributes-container">
                        <div *ngFor="let key of sustainabilityAttributes.keys" class="fc-product-detail-attribute">
                            <div>
                                <span
                                    ><strong>{{ sustainabilityAttributes[key].value }}</strong></span
                                >
                            </div>

                            <div *ngFor="let nested of sustainabilityAttributes.nestedKeys">
                                <ng-container *ngIf="!isEmpty(sustainabilityAttributes[key][nested])">
                                    <span
                                        >{{
                                            formatSustainabilityAttributesKey(
                                                sustainabilityAttributes[key],
                                                sustainabilityAttributes[key][nested]
                                            ) | translate
                                        }}:
                                    </span>
                                    <span>{{ sustainabilityAttributes[key][nested] }}</span>
                                </ng-container>
                            </div>
                        </div>
                    </div>
                </div>
            </fcp-accordion-item>
        </fcp-accordion>
    </div>
</div>
